<template>
  <confirmation-modal title-key="company.action.select" :confirm="confirm" :valid="valid">
    <wo-label v-t="'company.name'" />
    <po-selector v-model="selected" :search="searchCompany" v-focus="true" :label-factory="createCompanyLabel" />
    <wo-checkbox v-model="limitToCustomers" mod-block><span v-t="'company.filterCustomer'"></span></wo-checkbox>
  </confirmation-modal>
</template>

<script>

import { companyRepository } from '@/repository/company'

import ConfirmationModal from '@/components/modal/ConfirmationModal'

export default {
  components: { ConfirmationModal },
  props: {
    confirmCompany: Function,
    customersOnly: Boolean
  },
  data () {
    return {
      selected: undefined,
      limitToCustomers: false
    }
  },
  computed: {
    valid () {
      return !!this.selected
    }
  },
  created () {
    this.limitToCustomers = this.customersOnly
  },
  methods: {
    confirm () {
      return this.confirmCompany ? this.confirmCompany(this.selected) : this.selected
    },
    searchCompany (searchText) {
      const filter = { search_text: searchText, is_customer: this.limitToCustomers || undefined }
      return this.$store.dispatch(companyRepository.findAll, { filter })
    },
    createCompanyLabel: (option) => option.fullDisplayName
  }
}
</script>
